import { RootState } from "../store";
import { AuthState } from '../reducers/auth';

export const selectAuthenticatedUser = (state: RootState): AuthState => state.auth;

export const selectAuthenticatedUsersHousehold = (state) =>
  state.auth.authUserHouseholdId || undefined;
